import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LINKS = [
  { id: "idee", label: "Le Idee" },
  { id: "temi", label: "Temi" },
  { id: "manifesto", label: "Manifesto" },
  { id: "partecipa", label: "Partecipa" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, delay: 1.6, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-[#f4f4f2]/90 backdrop-blur-md border-b border-[#0a0d14]/10"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1500px] px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="logo-btn"
          onClick={() => go("top")}
          className="flex items-center gap-2 group"
        >
          <span className="font-mono-num text-xs text-[#d9381e] font-bold">100</span>
          <span className="font-display font-extrabold tracking-tighter text-lg md:text-xl uppercase text-[#0a0d14]">
            Idee per Verona
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="font-mono-num uppercase text-xs tracking-widest text-[#0a0d14]/70 hover:text-[#d9381e] transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta"
            onClick={() => go("partecipa")}
            className="bg-[#0d2c54] text-white px-5 py-2.5 font-semibold text-sm uppercase tracking-wide hover:bg-[#d9381e] transition-colors"
          >
            Proponi un'idea
          </button>
        </nav>

        <button
          data-testid="menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden font-mono-num uppercase text-xs tracking-widest border border-[#0a0d14] px-3 py-2"
        >
          {open ? "Chiudi" : "Menu"}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-[#0d2c54]"
          >
            <div className="px-5 py-4 flex flex-col">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-${l.id}`}
                  onClick={() => go(l.id)}
                  className="text-left py-3 font-display font-bold text-xl text-white border-b border-white/10"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
